export let imgBase = 'https://img.kamlung.net/hongqi/'
// let imgBase='https://ssy.kamlung.net/images/hongqi/'

// export let contactList = [
//     {
//         id: 1,
//         img: require('@/assets/img/contact/1.jpg'),
//         year: 1958,
//     },
//     {
//         id: 2,
//         img: require('@/assets/img/contact/2.jpg'),
//         year: 1965,
//     },
//     {
//         id: 3,
//         img: require('@/assets/img/contact/3.jpg'),
//         year: 1969,
//     },
//     {
//         id: 4,
//         img: require('@/assets/img/contact/4.jpg'),
//         year: 1980,
//     },
//     {
//         id: 5,
//         img: require('@/assets/img/contact/5.jpg'),
//         year: 1998,
//     },
//     {
//         id: 6,
//         img: require('@/assets/img/contact/6.jpg'),
//         year: 2000,
//     },
//     {
//         id: 7,
//         img: require('@/assets/img/contact/7.jpg'),
//         year: 2013,
//     },
//     {
//         id: 8,
//         img: require('@/assets/img/contact/8.jpg'),
//         year: 2020,
//     },
//     {
//         id: 9,
//         img: require('@/assets/img/contact/9.jpg'),
//         year: 2024,
//     },
//     {
//         id: 10,
//         img: require('@/assets/img/contact/10.jpg'),
//         year: 2025,
//     },
//     {
//         id: 11,
//         img: require('@/assets/img/contact/11.png'),
//         year: 2026,
//     },
// ]
export let contactList = [
    {
        id: 1,
        img: 'https://img.kamlung.net/hk/hongqi-contact/1.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1953,
    },
    {
        id: 2,
        img: 'https://img.kamlung.net/hk/hongqi-contact/2.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1958,
    },
    {
        id: 3,
        img: 'https://img.kamlung.net/hk/hongqi-contact/3.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1960,
    },
    {
        id: 4,
        img: 'https://img.kamlung.net/hk/hongqi-contact/4.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1966,
    },
    {
        id: 5,
        img: 'https://img.kamlung.net/hk/hongqi-contact/5.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 1978,
    },
    {
        id: 6,
        img: 'https://img.kamlung.net/hk/hongqi-contact/6.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2018,
    },
    {
        id: 7,
        img: 'https://img.kamlung.net/hk/hongqi-contact/7.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2019,
    },
    {
        id: 8,
        img: 'https://img.kamlung.net/hk/hongqi-contact/8.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2020,
    },
    {
        id: 9,
        img: 'https://img.kamlung.net/hk/hongqi-contact/9.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2022,
    },
    {
        id: 10,
        img: 'https://img.kamlung.net/hk/hongqi-contact/10.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2023,
    },
    {
        id: 11,
        img: 'https://img.kamlung.net/hk/hongqi-contact/11.jpg?iopcmd=thumbnail&type=4&width=680&quality=60',
        year: 2026,
    },
]
export let contactImgList = [
    'https://img.kamlung.net/hk/hongqi-contact/1.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/2.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/3.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/4.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/5.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/6.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/7.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/8.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/9.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/10.jpg',
    'https://img.kamlung.net/hk/hongqi-contact/11.jpg',
]
// export let carList = [
//     {
//         id: 1,
//         text: '',
//         title: 'E-HS9',
//         carArr: [
//             {
//                 id: 1,
//                 img: require('@/assets/img/cars/EV/E-HS9/1.png'),
//             },
//             {
//                 id: 2,
//                 img: require('@/assets/img/cars/EV/E-HS9/2.png'),
//             },
//             {
//                 id: 3,
//                 img: require('@/assets/img/cars/EV/E-HS9/3.png'),
//             },
//             {
//                 id: 4,
//                 img: require('@/assets/img/cars/EV/E-HS9/4.png'),
//             },
//             {
//                 id: 5,
//                 img: require('@/assets/img/cars/EV/E-HS9/5.png'),
//             },
//             {
//                 id: 6,
//                 img: require('@/assets/img/cars/EV/E-HS9/6.png'),
//             },
//         ],
//         iconArr: [
//             {
//                 id: 1,
//                 img: require('@/assets/img/cars/EV/E-HS9/color_1.png'),
//             },
//             {
//                 id: 2,
//                 img: require('@/assets/img/cars/EV/E-HS9/color_2.png'),
//             },
//             {
//                 id: 3,
//                 img: require('@/assets/img/cars/EV/E-HS9/color_3.png'),
//             },
//             {
//                 id: 4,
//                 img: require('@/assets/img/cars/EV/E-HS9/color_4.png'),
//             },
//             {
//                 id: 5,
//                 img: require('@/assets/img/cars/EV/E-HS9/color_5.png'),
//             },
//             {
//                 id: 6,
//                 img: require('@/assets/img/cars/EV/E-HS9/color_6.png'),
//             },
//         ]
//     },
//     {
//         id: 2,
//         text: '',
//         title: 'E-QM5',
//         carArr: [
//             {
//                 id: 1,
//                 img: require('@/assets/img/cars/EV/E-QM5/1.png'),
//             },
//             {
//                 id: 2,
//                 img: require('@/assets/img/cars/EV/E-QM5/2.png'),
//             },
//             {
//                 id: 3,
//                 img: require('@/assets/img/cars/EV/E-QM5/3.png'),
//             },
//         ],
//         iconArr: [
//             {
//                 id: 1,
//                 img: require('@/assets/img/cars/EV/E-QM5/color_1.png'),
//             },
//             {
//                 id: 2,
//                 img: require('@/assets/img/cars/EV/E-QM5/color_2.png'),
//             },
//             {
//                 id: 3,
//                 img: require('@/assets/img/cars/EV/E-QM5/color_3.png'),
//             },
//         ]
//     },
// ]

// export let carColorIcon = [
//     {
//         id: 1,
//         img: require('@/assets/img/H9/color_1.png'),
//         text: '',
//     },
//     {
//         id: 2,
//         img: require('@/assets/img/H9/color_2.png'),
//         text: '',
//     },
//     {
//         id: 3,
//         img: require('@/assets/img/H9/color_3.png'),
//         text: '',
//     },
//     {
//         id: 4,
//         img: require('@/assets/img/H9/color_4.png'),
//         text: '',
//     },
// ]
// export let aboutList = [
//     {
//         id: 1,
//         img: require('@/assets/img/homeAbout/1.jpg'),
//         text: 'history',
//     },
//     {
//         id: 2,
//         img: require('@/assets/img/homeAbout/2.jpg'),
//         text: 'Brand',
//     },
//     {
//         id: 3,
//         img: require('@/assets/img/homeAbout/3.jpg'),
//         text: 'Research & development',
//     },
//     {
//         id: 4,
//         img: require('@/assets/img/homeAbout/4.jpg'),
//         text: 'Achievements',
//     },
//     {
//         id: 5,
//         img: require('@/assets/img/homeAbout/5.jpg'),
//         text: 'Social responsibility',
//     },
// ]

export let eventsList = [
    {
        id: 1,
        img: require('@/assets/img/events2.jpg'),
        text: 'Hongqi E-HS9 Leads  Southeast Asia Silk Road Journey',
    },
    // {
    //     id: 2,
    //     img: require('@/assets/img/homeEvents/2.jpg'),
    //     text: 'Hongqi E-HS9 Awarded Top “Five-Star Safety” Rating by Euro NCAP',
    // },
    // {
    //     id: 3,
    //     img: require('@/assets/img/homeEvents/3.jpg'),
    //     text: 'Hongqi Introduces Multiple Models to the Czech and Slovak Markets, Blending Oriental Luxury with European Industrial Aesthetics',
    // },
    // {
    //     id: 4,
    //     img: require('@/assets/img/homeEvents/4.jpg'),
    //     text: 'Hongqi’s Dual Flagship Models Shine in Myanmar, Ushering in a New Chapter in the Southeast Asian Market',
    // },
    // {
    //     id: 5,
    //     img: require('@/assets/img/homeEvents/5.jpg'),
    //     text: 'Unstoppable Rise | Hongqi Launches in Poland, Opening a New Chapter of Oriental Luxury',
    // },
    // {
    //     id: 6,
    //     img: require('@/assets/img/homeEvents/6.jpg'),
    //     text: 'On February 26, China’s luxury automotive brand Hongqi officially launched two of its popular models, the HS7 and H6, at a grand event held in Jeddah, Saudi Arabia.',
    // },
]
// export let InteractList = [
//     {
//         id: 1,
//         img: require('@/assets/img/homeInteract/1.jpg'),
//         text: "The innovative wing-like design of the headlights highly enhances #HONGQI #OUSADO's aesthetic appeal.",
//     },
//     {
//         id: 2,
//         img: require('@/assets/img/homeInteract/2.jpg'),
//         text: '#HONGQI #E_HS9 welcomes all your groceries and belongings with room to spare.',
//     },
//     {
//         id: 3,
//         img: require('@/assets/img/homeInteract/3.jpg'),
//         text: 'Inspired by ancient Chinese royal architecture, the front fascia features a harmonious design. #HONGQI #OUSADO',
//     },
// ]

export let detailNvgList = [
    // {
    //     id: 1,
    //     idN: 'showroom',
    //     label: '3D Showroom',
    // },
    {
        id: 2,
        idN: 'highlights',
        label: 'MODEL Highlights',
        lang: 'public.highlights'
    },
    {
        id: 3,
        idN: 'specifications',
        label: 'Specifications',
        lang: 'public.parameters'
    },
    {
        id: 4,
        idN: 'exterior',
        label: 'Exterior Details',
        lang: 'public.exterior'
    },
    {
        id: 5,
        idN: 'Interior',
        label: 'Interior',
        lang: 'public.Interior'
    },
    {
        id: 6,
        idN: 'video',
        label: 'video',
        lang: 'public.video'
    },
    {
        id: 7,
        idN: 'gallery',
        label: 'Gallery',
        lang: 'public.gallery'
    },

    // {
    //     id: 5,
    //     idN: 'TEST',
    //     label: 'TEST DRIVE',
    // },
    // {
    //     id: 6,
    //     idN: 'manual',
    //     label: 'service manual',
    // },
]

// export let modelList = [
//     {
//         id: 1,
//         img: require('@/assets/img/modelList/1.jpg'),
//         title: 'Deluxe Cabin Layout',
//         text: 'The whole view of majestic, the fine workmanship, instantaneous fall in love.'
//     },
//     {
//         id: 2,
//         img: require('@/assets/img/modelList/2.jpg'),
//         title: 'lashy Welcome Light',
//         text: 'What is breathtaking is not only the sense of the lit ceremony, but also the coming future technology.'
//     },
//     {
//         id: 3,
//         img: require('@/assets/img/modelList/3.jpg'),
//         title: 'Two-Tone Color Body',
//         text: 'The connotation is deep and the color separation curve is soft and flexible, and the beauty of neutralization is incisive and vivid.'
//     },
//     {
//         id: 4,
//         img: require('@/assets/img/modelList/4.jpg'),
//         title: 'Powerful Batteries',
//         text: 'Large-capacity, high-performance, move at great speed, take you on a further trip.'
//     },
// ]


export const carConfigData = [
    {
        name: "Executive",
        arr: [
            {
                id: 1,
                prop_nameEn: 'LxWxH[mm]',
                prop_valCttEn: "5209x2010x1731",
            },
            {
                id: 2,
                prop_nameEn: 'Wheelbase[mm]',
                prop_valCttEn: 3110,
            },
            {
                id: 3,
                prop_nameEn: 'Maximum Battery Capacity(kWh)',
                prop_valCttEn: 84,
            },
            {
                id: 4,
                prop_nameEn: 'Maximum Motor Power(kw)',
                prop_valCttEn: "160+160",
            },
            {
                id: 5,
                prop_nameEn: 'Maximum Torque(N·m)',
                prop_valCttEn: "300+300",
            },
            {
                id: 6,
                prop_nameEn: 'Driving Range（WLTP）',
                prop_valCttEn: "≥380",
            },
        ],
    },
    {
        name: "Deluxe",
        arr: [
            {
                id: 1,
                prop_nameEn: 'LxWxH[mm]',
                prop_valCttEn: "5209x2010x1731",
            },
            {
                id: 2,
                prop_nameEn: 'Wheelbase[mm]',
                prop_valCttEn: 3110,
            },
            {
                id: 3,
                prop_nameEn: 'Maximum Battery Capacity(kWh)',
                prop_valCttEn: 99,
            },
            {
                id: 4,
                prop_nameEn: 'Maximum Motor Power(kw)',
                prop_valCttEn: "160+245",
            },
            {
                id: 5,
                prop_nameEn: 'Maximum Torque(N·m)',
                prop_valCttEn: "300+450",
            },
            {
                id: 6,
                prop_nameEn: 'Driving Range（WLTP）',
                prop_valCttEn: "≥441",
            },
        ],
    },
    {
        name: "Flagship",
        arr: [
            {
                id: 1,
                prop_nameEn: 'LxWxH[mm]',
                prop_valCttEn: "5209x2010x1731",
            },
            {
                id: 2,
                prop_nameEn: 'Wheelbase[mm]',
                prop_valCttEn: 3110,
            },
            {
                id: 3,
                prop_nameEn: 'Maximum Battery Capacity(kWh)',
                prop_valCttEn: 99,
            },
            {
                id: 4,
                prop_nameEn: 'Maximum Motor Power(kw)',
                prop_valCttEn: "160+245",
            },
            {
                id: 5,
                prop_nameEn: 'Maximum Torque(N·m)',
                prop_valCttEn: "300+450",
            },
            {
                id: 6,
                prop_nameEn: 'Driving Range（WLTP）',
                prop_valCttEn: "≥441",
            },
        ],
    },
    {
        name: "Long Range",
        arr: [
            {
                id: 1,
                prop_nameEn: 'LxWxH[mm]',
                prop_valCttEn: "5209x2010x1731",
            },
            {
                id: 2,
                prop_nameEn: 'Wheelbase[mm]',
                prop_valCttEn: 3110,
            },
            {
                id: 3,
                prop_nameEn: 'Maximum Battery Capacity(kWh)',
                prop_valCttEn: 99,
            },
            {
                id: 4,
                prop_nameEn: 'Maximum Motor Power(kw)',
                prop_valCttEn: "160+245",
            },
            {
                id: 5,
                prop_nameEn: 'Maximum Torque(N·m)',
                prop_valCttEn: "300+450",
            },
            {
                id: 6,
                prop_nameEn: 'Driving Range（WLTP）',
                prop_valCttEn: "≥515",
            },
        ],
    },
]

export const homeSwiper = require('@/assets/img/home.jpg')
export const homeMobileSwiper = require('@/assets/img/home_mobile.jpg')